export const routes = {
  index: '/',
  health: '/health',
  search: '/search',
  privacy: '/privacy',
  termsOfUse: '/terms-of-use',
}
